import { Component, Input } from '@angular/core';

import { TransformPricePipe } from '@cure-pipes/transform-price.pipe';

@Component({
  selector: 'app-order-summary',
  standalone: true,
  imports: [TransformPricePipe],
  templateUrl: './order-summary.component.html',
  styleUrl: './order-summary.component.scss',
})
export class OrderSummaryComponent {
  @Input({ required: true }) count: number;
  @Input({ required: true }) totalPrice: number;
  protected readonly print = print;
}
